export default __webpack_public_path__ + "static/media/phases_welcome_home.c2632105.webp";